import type { FunctionComponent, PropsWithChildren } from 'react';
import { Card, CardBanner } from '@george-labs.com/design-system';

import styles from './DevToolsCard.module.scss';

interface DevToolsCardProps extends PropsWithChildren {
    title: string;
}

export const DevToolsCard: FunctionComponent<DevToolsCardProps> = ({ title, children }) => (
    <>
        <CardBanner className="text-capitalize">{title}</CardBanner>
        <Card useCardBody={false} className={`d-flex p-2 ${styles.card}`}>
            {children}
        </Card>
    </>
);
